import { CountryCode } from "config/BaseConfig";
import { Checkbox } from "rsuite";
import classes from "./SecondaryInputCheckbox.module.scss";

interface Props {
  value: string | undefined;
}

const SecondaryInputCheckbox = ({ value }: Props) => {
  return (
    <Checkbox
      className={
        CountryCode === "US" ? classes.main_css_us : classes.main_css_jp
      }
      key={value}
      value={value}
    >
      <span className={classes.text}>{value}</span>
    </Checkbox>
  );
};

export default SecondaryInputCheckbox;
